import React, {useEffect} from 'react'
import Carousel from 'react-bootstrap/Carousel'
import Col from 'react-bootstrap/Col'
// import $ from "jquery"
import {BannerContent} from './BannerContent.tsx'
import {useEventProvider} from '../../../providers/EventProvider.tsx'
import {useStoreBanners} from '../../../store/useStoreBanners.ts'
import {useStoreMessages} from '../../../store/useStoreMessages.ts'

const Banners = () => {
    const {newBanners} = useEventProvider()
    const fetBanners = useStoreBanners((state) => state.fetch)
    const bannersLeft = useStoreBanners((state) => state.bannersLeft)
    const bannersRight = useStoreBanners((state) => state.bannersRight)
    const loaded = useStoreBanners((state) => state.loaded)
    const setLoaded = useStoreBanners((state) => state.setLoaded)
    const messageAlert = useStoreMessages((state) => state.messageAlert)

    useEffect(() => {
        fetBanners()
    }, [loaded])

    useEffect(() => {
        if (newBanners.data) {
            setLoaded(false)
            delete newBanners.data
        }
    }, [newBanners])

    function buildBanners(banners) {
        return (
            <Col lg={6}>
                {banners.length > 1 ? (
                    <Carousel
                        fade
                        controls={false}
                        slide={false}
                        indicators={false}>
                        {banners.map((banner) => (
                            <Carousel.Item key={banner.id}>
                                <BannerContent banner={banner} />
                            </Carousel.Item>
                        ))}
                    </Carousel>
                ) : (
                    banners.map((banner) => (
                        <div key={banner.id}>
                            <BannerContent banner={banner} />
                        </div>
                    ))
                )}
            </Col>
        )
    }

    return (
        <>
            {bannersLeft.length > 0 &&
                !messageAlert &&
                buildBanners(bannersLeft)}
            {bannersRight.length > 0 && buildBanners(bannersRight)}
        </>
    )
}

export default Banners
